import { render, staticRenderFns } from "./CustomerNotOkOnPhone.vue?vue&type=template&id=25f6fea8&"
import script from "./CustomerNotOkOnPhone.vue?vue&type=script&lang=js&"
export * from "./CustomerNotOkOnPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports